import React from "react";
import { Navigate } from "react-router-dom";

import { checkStateExpiry } from "../localStorage";

const SessionExpiryRoute = ({ children }) => {
  let isExpiry = checkStateExpiry();
  if (isExpiry) {
    return <Navigate to="/logout" />;
  }
  return children;
};

export default SessionExpiryRoute;
